import { useContext } from 'react';
import { AuthContext } from './AuthContext';

export function useLoggedInLocation(): string | undefined {
	const { locationId } = useContext(AuthContext);
	return locationId;
}
